import * as actionTypes from "../actions/actionTypes";


const initState = {
    chatLoading: false,
    chat: null,
    error: null
};

const initGetChat = (state, action) => {
    return {
        ...state,
        chatLoading: action.chatLoading
    }
};

const successGetChat = (state, action) => {
    return {
        ...state,
        chatLoading: action.chatLoading,
        chat: action.chat
    }
};

const failGetChat = (state, action) => {
    return {
        ...state,
        chatLoading: action.chatLoading,
        error: action.error
    }
};

const runCleanChat = (state, action) => {
    return {
        ...state,
        chat: action.chat
    }
};

// const initCreateMessage = (state, action)=>{
//     return {
//         ...state,

//     }
// }



const Reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.INIT_GET_CHAT: return initGetChat(state, action)
        case actionTypes.SUCCESS_GET_CHAT: return successGetChat(state, action)
        case actionTypes.FAIL_GET_CHAT: return failGetChat(state, action)
        case actionTypes.CLEAN_CHAT: return runCleanChat(state, action)
        default: return { ...state }
    }
};

export default Reducer